import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from '../../i18n/FormattedMessage';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import Scheduler, {
  SchedulerData,
  ViewTypes,
  DnDSource,
} from 'react-big-scheduler';
import 'react-big-scheduler/lib/css/style.css';
import dragTypes from '../../libs/constants/dragTypes';
import {
  reportCategoriesWithRoutes,
  REPORT_CATEGORIES,
} from '../../utils/Constants';
import JobListRow from '../JobList/JobListRow';
import getJobListAction, {
  getJobDetailsAction,
  setCalenderViewData,
  getTeamListWithFiltersAction,
} from '../../redux/actions/jobLinkActions';
import updateStatusAction from '../../redux/actions/updateStatus';
import {
  getTeams,
  displayToast,
  getCustomerId,
  getTeamStatus,
  checkPermission,
} from '../../_helpers/commonFunctions';
import JobLinkPopUp from '../JobLinkPopUp/JobLinkPopUp';
import CustomMultiSelectDropDown from '../CustomMultiSelectDropdown';
import { subPermissions, permissions } from '../../libs/constants/permissions';
import popUpData from './PopUpData';
import JobDetailPopOver from './JobDetailPopUp';
import { EVENTS, saveEvent } from '../../utils/eventAnalytics';

let TEAMS_PER_PAGE = 50;

/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
export class Basic extends Component {
  constructor(props) {
    super(props);
    // Posición de scroll horizontal preservada en memoria (no en localStorage).
    // Refleja siempre la última posición real del usuario.
    this.lastScrollLeft = 0;
    // Referencia estable al nodo scrolleable interno de react-big-scheduler.
    this.schedulerContentEl = null;
    // Id del requestAnimationFrame pendiente para restaurar el scroll.
    this.scrollRestoreRaf = null;
    this.state = {
      viewModel: new SchedulerData(),
      taskDndSource: new DnDSource(
        (props1) => props1.task,
        JobListRow,
        dragTypes.TASK
      ),
      mapDndSources: [],
      showChangeStatus: false,
      teamId: '',
      selectedStatus: '',
      reportCategoriesSelected: {},
      search: '',
    };
    this.isMyPermissionChange = checkPermission(
      subPermissions.scheduleMyJobs,
      permissions.jobLink
    );
    this.isOthersPermissionChange = checkPermission(
      subPermissions.scheduleOthersJobs,
      permissions.jobLink
    );
  }

  getInitialScheduler = () => {
    const { startDate } = this.props.calenderViewData;
    const { timeZone } = this.props.auth.login.user;
    const currentTimeInTimezone = moment().tz(timeZone).format('YYYY-MM-DD');
    const schedulerData = new SchedulerData(
      startDate || currentTimeInTimezone, 
      this.props.viewType || ViewTypes.Day,
      false,
      false,
      {
        schedulerWidth: '75%',
        dayCellWidth: '7%',
        views: [
          {
            viewName: 'Day',
            viewType: ViewTypes.Day,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: 'Week',
            viewType: ViewTypes.Custom,
            showAgenda: false,
            isEventPerspective: false,
          },
        ],
        headerEnabled: false,
        // Desactiva el auto-scroll de react-big-scheduler a la hora actual.
        // Por defecto (scrollToSpecialMomentEnabled: true) la librería fuerza
        // el scrollLeft hacia el "momento especial" (localeMoment() = hora
        // actual) en cada re-render tras setEvents. Eso ocurre justo después
        // de un drag & drop y mandaba el scroll al extremo derecho, pisando la
        // posición del usuario. Al desactivarlo, la preservación manual del
        // scroll (captureScrollLeft/restoreScrollPosition) toma el control.
        scrollToSpecialMomentEnabled: false,
      },
      {
        getCustomDateFunc: this.getCustomDate,
      }
    );
    schedulerData.localeMoment.locale('en');
    return schedulerData;
  };

  setInitialScheduler = () => {
    const { setSchedulerData, setTaskDndSource } = this.props;
    const schedulerData = this.getInitialScheduler();
    this.setState(
      {
        viewModel: schedulerData,
      },
      () => {
        this.setCalenderData(this.state.viewModel, { id: 2 });
        setSchedulerData(this.state.viewModel);
        setTaskDndSource(this.state.taskDndSource);
      }
    );
  };

  getAllJobsWithResource = () => {
    const { teamList } = this.props.teamListDetails;
    const jobs = { customerNames: {} };
    teamList.forEach((team) => {
      jobs[team._id] = [...team.job];
      jobs.customerNames[team._id] = team.createdFor;
    });
    return jobs;
  };

  getEvents = () => {
    const events = [];
    const jobsWithResource = this.getAllJobsWithResource();
    Object.keys(jobsWithResource).forEach((resource) => {
      const jobs = jobsWithResource[resource];
      if (resource !== 'customerNames') {
        jobs.forEach((job) => {
          const { timeZone } = this.props.auth.login.user;
          if (
            moment.tz(job.startDateTime, timeZone).valueOf() >=
            moment.tz(timeZone).startOf('day').valueOf()
          ) {
            const event = {};
            const customerName = jobsWithResource.customerNames[
              resource
            ].filter((customer) => job.createdFor === customer._id);
            event.id = job._id;
            event.resourceId = resource;
            event.title =
              customerName.length && customerName[0].businessName
                ? customerName[0].businessName
                : job.description;
            
            const startDateAdminTimeZone = moment.tz(job.startDateTime, timeZone);
            const endDateAdminTimeZone = moment.tz(job.endDateTime, timeZone);
            const startDate = startDateAdminTimeZone.format('YYYY-MM-DD HH:mm');
            const endDate = endDateAdminTimeZone.format('YYYY-MM-DD HH:mm');
            event.start = startDate;
            event.end = endDate;
            event.startResizable = true;
            event.endResizable = true;
            event.state = {
              reportCategory: job.reportCategory,
              duration: job.duration,
              type: job.type,
            };
            events.push(event);
          }
        });
      }
    });
    return events;
  };

  getResourceListForNewHeight = () => {
    if (window.innerWidth >= 1900 && TEAMS_PER_PAGE !== 50) {
      TEAMS_PER_PAGE = 50;
      this.getResources();
    } else if (window.innerWidth < 1900 && TEAMS_PER_PAGE !== 30) {
      TEAMS_PER_PAGE = 30;
      this.getResources();
    }
  };

  // getTeamListWithPermissions =
  //   (id, teamListArray) => teamListArray.filter(item => item.customerId === id);

  static getDerivedStateFromProps(props, state) {
    if (state.search !== props.search) {
      return { search: props.search };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const {
      resourceReportCategory,
      statusUpdateError,
      isStatusUpdated,
      handleOnSearch,
      isSearch,
    } = this.props;

    this.getResourceListForNewHeight();

    // Extract team and job list success validation
    this.handleTeamAndJobListSuccess(prevProps);

    // Handle status updates
    this.handleStatusUpdates(prevProps, isStatusUpdated, statusUpdateError);

    // Handle resource category changes
    if (this.hasResourceCategoryChanged(prevProps, resourceReportCategory)) {
      this.getResources(undefined, undefined, true);
    }

    // Handle search updates
    if (isSearch && prevProps.isSearch !== isSearch) {
      this.getResources();
      handleOnSearch(false);
    }

    // Handle permission changes
    this.handlePermissionChanges();

    // Restore scroll position if needed
    this.handleScrollPosition(prevProps);
  }

  // Helper methods
  areSuccessNotEqual = (left, right) =>
    left.isSuccess && left.isSuccess !== right.isSuccess;

  areNotEqual = (left, right) => left && left !== right;

  handleTeamAndJobListSuccess(prevProps) {
    const { teamListDetails: currentTeam, jobList: currentJob } = this.props;
    const { teamListDetails: prevTeam, jobList: prevJob } = prevProps;
    const hasTeamSuccess = this.areSuccessNotEqual(currentTeam, prevTeam);
    const hasJobSuccess = this.areSuccessNotEqual(currentJob, prevJob);

    if (hasTeamSuccess || hasJobSuccess) {
      const teams = currentTeam ? getTeams(currentTeam.teamList) : [];
      const schedulerData = this.state.viewModel;
      schedulerData.setResources(teams);
      schedulerData.setEvents(this.getEvents());
      this.setState({ viewModel: schedulerData });
    }
  }

  handleStatusUpdates(prevProps, isStatusUpdated, statusUpdateError) {
    if (this.areNotEqual(isStatusUpdated, prevProps.isStatusUpdated)) {
      displayToast('Status updated successfully', 'success');
      this.getResources(this.state.viewModel, 1);
    } else if (
      this.areNotEqual(statusUpdateError, prevProps.statusUpdateError)
    ) {
      displayToast(statusUpdateError, 'error');
    }
  }

  hasResourceCategoryChanged(prevProps, resourceReportCategory) {
    const prevResource = JSON.stringify(prevProps.resourceReportCategory);
    const currentResource = JSON.stringify(resourceReportCategory);
    return prevResource !== currentResource;
  }

  handlePermissionChanges() {
    const { jobLink } = permissions;
    const { scheduleMyJobs, scheduleOthersJobs } = subPermissions;

    const myPermission = checkPermission(scheduleMyJobs, jobLink);
    const othersPermission = checkPermission(scheduleOthersJobs, jobLink);

    if (this.isMyPermissionChange !== myPermission) {
      this.isMyPermissionChange = myPermission;
      this.getResources();
    }

    if (this.isOthersPermissionChange !== othersPermission) {
      this.isOthersPermissionChange = othersPermission;
      this.getResources();
    }
  }

  handleScrollPosition(prevProps) {
    const { teamListDetails: currentTeam, jobList: currentJob } = this.props;
    const { teamListDetails: prevTeam, jobList: prevJob } = prevProps;
    const hasTeamSuccess = this.areSuccessNotEqual(currentTeam, prevTeam);
    const hasJobSuccess = this.areSuccessNotEqual(currentJob, prevJob);

    if (hasTeamSuccess || hasJobSuccess) {
      // El nodo scrolleable puede haberse re-montado; reengancha el listener
      // (getSchedulerContentEl revalida el nodo cacheado) y restaura la
      // posición preservada.
      this.attachScrollListener();
      this.restoreScrollPosition();
    }
  }

  getResources = (
    schedulerData = this.props.calenderViewData,
    activePage = this.props.teamListDetails.currentPage,
    isDivision = false
  ) => {
    const { resourceReportCategory, isSearch, teamListDetails } = this.props;
    const { currentPage, pages, isfetching } = teamListDetails;
    const { search } = this.state;
    const { timeZone } = this.props.auth.login.user;
    const momentStartDate = schedulerData.startDate ? 
      moment.tz(schedulerData.startDate, 'YYYY-MM-DD', timeZone).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      }): moment.tz(timeZone).startOf('day');
    const momentEndDate = schedulerData.endDate ?
      moment.tz(schedulerData.endDate, 'YYYY-MM-DD', timeZone).set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999,
      }) : moment.tz(timeZone).endOf('day');
    const queryParams = {
      startDateTime: momentStartDate.valueOf(),
      endDateTime: momentEndDate.valueOf(),
      search,
    };
    if (resourceReportCategory)
      queryParams.reportCategories = resourceReportCategory;
    if (
      !isfetching &&
      (currentPage <= pages || (currentPage === 1 && pages === 0))
    ) {
      this.props.getTeamListWithFiltersAction(
        queryParams,
        isSearch || isDivision ? 1 : activePage,
        TEAMS_PER_PAGE
      );
    }
  };

  handleTeamStatusUpdation = (status, userId) => {
    this.setState({ showChangeStatus: false, teamId: 0 });
    const { teamId } = this.state;
    const upperStatus = status.replace(/ +/g, '').toUpperCase();
    const updateSatusData = {
      customerId: getCustomerId(),
      employeeId: teamId || userId,
      status: upperStatus === 'CLOCKEDOUT' ? 'CHECKOUT' : upperStatus,
      day: moment(new Date()).format('YYYY-MM-DD'),
    };
    this.props.updateStatusAction(updateSatusData);
  };

  pushCategory = (name, value) => {
    let categoriesSelected = {};
    let selectedCategory = [];
    categoriesSelected = { ...this.state.reportCategoriesSelected };
    categoriesSelected[name] = value;
    this.setState({ reportCategoriesSelected: { ...categoriesSelected } });
    selectedCategory = Object.keys(categoriesSelected);
    return selectedCategory;
  };

  deleteCategory = (name) => {
    let categoriesSelected = {};
    let selectedCategory = [];
    categoriesSelected = { ...this.state.reportCategoriesSelected };
    delete categoriesSelected[name];
    this.setState({ reportCategoriesSelected: { ...categoriesSelected } });
    selectedCategory = Object.keys(categoriesSelected);
    return selectedCategory;
  };

  setCategories = (selectedCategory) => {
    this.props.setResourceReportCategory(selectedCategory);
  };

  handleCategoryChange = (name, value) => {
    let selectedCategory = [];
    if (!value) {
      selectedCategory = this.deleteCategory(name);
    } else {
      selectedCategory = this.pushCategory(name, value);
    }
    this.setCategories(selectedCategory);
  };

  componentDidMount() {
    const { setNewEvent } = this.props;
    this.setInitialScheduler();
    setNewEvent(() => this.newEvent);
    this.getResourceListForNewHeight();
    this.props.onRef(this);

    // Adjunta el listener de scroll directamente al nodo scrolleable interno
    // de react-big-scheduler. El evento `scroll` del DOM no burbujea, por lo
    // que un onScroll en el wrapper externo no siempre lo captura.
    this.attachScrollListener();
  }

  componentWillUnmount() {
    if (this.scrollRestoreRaf) {
      globalThis.cancelAnimationFrame(this.scrollRestoreRaf);
      this.scrollRestoreRaf = null;
    }
    if (this.attachScrollTimeout) {
      clearTimeout(this.attachScrollTimeout);
      this.attachScrollTimeout = null;
    }
    if (this.schedulerContentEl) {
      this.schedulerContentEl.removeEventListener(
        'scroll',
        this.saveScrollPosition
      );
    }
    this.props.onRef(null);
  }

  // Engancha el listener de scroll al contenido del scheduler. Como el nodo se
  // monta de forma asíncrona (tras el setState inicial), reintenta hasta
  // encontrarlo (máximo ~1s) sin bloquear.
  attachScrollListener = (attemptsLeft = 20) => {
    const contentEl = this.getSchedulerContentEl();
    if (contentEl) {
      contentEl.removeEventListener('scroll', this.saveScrollPosition);
      contentEl.addEventListener('scroll', this.saveScrollPosition, {
        passive: true,
      });
      return;
    }
    if (attemptsLeft > 0) {
      this.attachScrollTimeout = setTimeout(
        () => this.attachScrollListener(attemptsLeft - 1),
        50
      );
    }
  };

  updateEventStart = (schduler, current, newStart) => {
    this.captureScrollLeft();
    const newStartDate = new Date(newStart);
    const diff = new Date(current.end).getTime() - newStartDate.getTime();
    const duration = diff / (1000 * 60 * 60);
    this.props.getJobDetailsAction(current.id);
    this.props.setCurrentEvent({ ...current, save: true, isNew: false, start: newStartDate.toISOString(), duration });
    this.props.toggleEditJobModal(true);
  }
  updateEventEnd = (schduler, current, newEnd) => {
    this.captureScrollLeft();
    const newEndDate = new Date(newEnd);
    const diff = newEndDate.getTime() - new Date(current.start).getTime();
    const duration = diff / (1000 * 60 * 60);
    this.props.getJobDetailsAction(current.id);
    this.props.setCurrentEvent({ ...current, save: true, isNew: false, duration, end: newEndDate.toISOString() });
    this.props.toggleEditJobModal(true);
  }

  // Obtiene (y cachea) el nodo scrolleable horizontal interno de
  // react-big-scheduler. NO es el lastChild de `.scheduler-view` (ese es el
  // header). El contenido scrolleable real es el div con overflow:auto que
  // envuelve a `.scheduler-content`. Lo localizamos a partir de esa clase y
  // subimos a su contenedor scrolleable directo.
  getSchedulerContentEl = () => {
    if (
      this.schedulerContentEl &&
      document.body.contains(this.schedulerContentEl)
    ) {
      return this.schedulerContentEl;
    }
    const content = document.querySelector(
      '.scheduler-view .scheduler-content'
    );
    // .scheduler-content -> padre (div width/height) -> padre (div overflow:auto)
    this.schedulerContentEl =
      content?.parentElement?.parentElement ?? null;
    return this.schedulerContentEl;
  };

  // Captura la posición actual del scroll horizontal en memoria.
  captureScrollLeft = () => {
    const contentEl = this.getSchedulerContentEl();
    if (contentEl) {
      this.lastScrollLeft = contentEl.scrollLeft;
    }
  };

  // Handler de onScroll: guarda la última posición real del usuario.
  // El evento burbujea desde el div interno con overflow:auto de la librería.
  saveScrollPosition = () => {
    this.captureScrollLeft();
  };

  // Ajusta el scrollLeft objetivo para que nunca caiga EXACTAMENTE en 0 ni en
  // el máximo. react-big-scheduler dispara onScrollLeft/onScrollRight (que en
  // vista Day hacen prev()/next() y reposicionan el calendario) cuando el
  // scrollLeft llega justo a 0 o al máximo. Como nuestra restauración escribe
  // scrollLeft programáticamente, aterrizar en el borde re-dispararía esa
  // paginación y mandaría el scroll al otro extremo. Un offset de 1px evita el
  // trigger sin desplazamiento perceptible.
  clampAwayFromEdges = (value, maxScrollLeft) => {
    if (maxScrollLeft <= 2) return value;
    let target = Math.min(value, maxScrollLeft);
    if (target <= 0) target = 1;
    else if (target >= maxScrollLeft) target = maxScrollLeft - 1;
    return target;
  };

  // Restaura la posición preservada tras un re-render, reintentando durante
  // varios frames. react-big-scheduler mide el scrollbar en su propio
  // componentDidUpdate (resolveScrollbarSize -> setState), lo que dispara un
  // segundo repintado que cambia el ancho del contenido; un solo
  // requestAnimationFrame aplicaría el scrollLeft sobre un layout intermedio y
  // el navegador lo recortaría a una posición equivocada. Reintentamos hasta
  // que el valor se mantenga estable o se agoten los intentos.
  restoreScrollPosition = (attemptsLeft = 5) => {
    if (!this.lastScrollLeft) return;
    // Evita solapar varias secuencias de restauración simultáneas.
    if (this.scrollRestoreRaf) {
      globalThis.cancelAnimationFrame(this.scrollRestoreRaf);
    }
    this.scrollRestoreRaf = globalThis.requestAnimationFrame(() => {
      this.scrollRestoreRaf = null;
      const contentEl = this.getSchedulerContentEl();
      if (!contentEl) return;

      const maxScrollLeft = contentEl.scrollWidth - contentEl.clientWidth;
      const target = this.clampAwayFromEdges(this.lastScrollLeft, maxScrollLeft);

      if (contentEl.scrollLeft !== target) {
        contentEl.scrollLeft = target;
      }

      // Si el layout aún no permite alcanzar la posición guardada (el contenido
      // todavía se está midiendo), reintenta en el siguiente frame.
      const notReachedYet =
        Math.abs(contentEl.scrollLeft - target) > 1 &&
        maxScrollLeft < this.lastScrollLeft;
      if (notReachedYet && attemptsLeft > 1) {
        this.restoreScrollPosition(attemptsLeft - 1);
      }
    });
  };

  render() {
    const {
      viewModel,
      taskDndSource,
      mapDndSources,
      showChangeStatus,
      selectedStatus,
      reportCategoriesSelected,
    } = this.state;
    const {
      teamListDetails,
      reportCategories,
      isStatusUpdateFetching,
      jobList,
    } = this.props;
    const dndSources = [taskDndSource, ...mapDndSources];
    const filteredReportCategories = reportCategories.filter((category) => {
      const { Other, WorkOrder, Quote } = reportCategoriesWithRoutes;
      return category !== Other && category !== WorkOrder && category !== Quote;
    });

    return (
      <div style={{ position: 'relative', top: '20px', right: '11px' }}>
        <div>
          {(teamListDetails.isfetching &&
            teamListDetails.currentPage === 1 &&
            !teamListDetails.teamList.length) ||
          jobList.isFetching ||
          isStatusUpdateFetching ? (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          ) : (
            <div ref={this.schedulerRef}>
              <InfiniteScroll
                className="job-link-table"
                scrollableTarget="scrollableDiv"
                dataLength={
                  this.state.viewModel.resources &&
                  this.state.viewModel.resources.length
                }
                next={() =>
                  this.getResources(
                    this.state.viewModel,
                    this.props.teamListDetails.currentPage + 1
                  )
                }
                hasMore={
                  !this.props.teamListDetails.isfetching &&
                  this.props.teamListDetails.currentPage <
                    this.props.teamListDetails.pages
                }
                endMessage={
                  !this.props.teamListDetails.teamList.length &&
                  !this.props.teamListDetails.isfetching ? (
                    <div className="end-message"></div>
                  ) : (
                    ''
                  )
                }
              >
                <Scheduler
                  schedulerData={viewModel}
                  resourceType="popover-quote"
                  resourceCategory="popover-type"
                  prevClick={this.prevClick}
                  nextClick={this.nextClick}
                  onSelectDate={this.onSelectDate}
                  onViewChange={this.onViewChange}
                  eventItemClick={this.eventClicked}
                  moveEvent={this.moveEvent}
                  // newEvent={this.newEvent}
                  onScrollLeft={this.onScrollLeft}
                  onScrollRight={this.onScrollRight}
                  onEventResize={this.resizeEvent}
                  updateEventStart={this.updateEventStart}
                  updateEventEnd={this.updateEventEnd}
                  dndSources={dndSources}
                  eventItemPopoverTemplateResolver={
                    this.eventItemPopoverTemplateResolver
                  }
                  handleClickResource={this.slotClickedFunc}
                  ResourceHeaderComponent={
                    <CustomMultiSelectDropDown
                      dataTip="Change to another division and Change the working status below"
                      dataFor="joblink-division-tooltip"
                      className="dropdown custom-drop-option"
                      dropDownList={filteredReportCategories}
                      name="reportCategory"
                      handleOnChange={this.handleCategoryChange}
                      placeholder="Division"
                      selectedValues={Object.keys(reportCategoriesSelected)}
                      dropItemSelected={reportCategoriesSelected}
                      width="189px"
                    />
                  }
                  resourceStatus={{
                    slotId: this.state.teamId,
                    resourceStatusComponent: showChangeStatus ? (
                      <JobLinkPopUp
                        heading="Change Status"
                        bodyItems={popUpData}
                        onClickItem={this.handleTeamStatusUpdation}
                        onClickCross={() =>
                          this.setState({ showChangeStatus: false, teamId: 0 })
                        }
                        selectedStatus={selectedStatus}
                      />
                    ) : null,
                  }}
                  EndMessage={
                    <div className="errorMessage">
                      <FormattedMessage
                        id="No Team Members Found!"
                        defaultMessage="No Team Members Found!"
                      />
                    </div>
                  }
                />
              </InfiniteScroll>
              {teamListDetails.isfetching && (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  eventItemPopoverTemplateResolver = (
    schedulerData,
    eventItem,
    title,
    start,
    end,
    statusColor
  ) => (
    <JobDetailPopOver
      title={title}
      start={start}
      end={end}
      statusColor={statusColor}
      eventItem={eventItem}
    />
  );

  slotClickedFunc = (slot) => {
    const { teamId } = this.state;
    if ((slot && slot.slotId !== teamId) || !teamId) {
      this.setState({
        showChangeStatus: true,
        teamId: slot.slotId,
        selectedStatus: getTeamStatus(
          this.props.teamListDetails.teamList,
          slot.slotId
        ),
      });
    }
  };

  getCustomDate = (schedulerData, num, date = undefined) => {
    let selectDate = schedulerData.startDate;
    if (date !== undefined) selectDate = date;

    const startDate =
      num === 0
        ? selectDate
        : schedulerData
            .localeMoment(selectDate)
            .add(7 * num, 'days')
            .format('YYYY-MM-DD');
    const endDate = schedulerData
      .localeMoment(startDate)
      .add(6, 'days')
      .format('YYYY-MM-DD');
    const cellUnit = 1;

    return {
      startDate,
      endDate,
      cellUnit,
    };
  };

  setCalenderData = (schedulerData, prevView) => {
    this.props.setCalenderViewData({
      startDate: schedulerData.startDate,
      endDate: schedulerData.endDate,
    });
    this.getResources(
      schedulerData,
      prevView && prevView.id === 2 ? 1 : undefined
    );
  };

  prevClick = (schedulerData) => {
    schedulerData.prev();
    this.setState(
      {
        viewModel: schedulerData,
      },
      () => this.setCalenderData(this.state.viewModel)
    );
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    this.setState(
      {
        viewModel: schedulerData,
      },
      () => this.setCalenderData(this.state.viewModel)
    );
  };

  onViewChange = (schedulerData, view) => {
    if (this.state.viewModel.viewType !== view.viewType) {
      schedulerData.setViewType(
        view.viewType,
        view.showAgenda,
        view.isEventPerspective
      );
      schedulerData.setEvents(this.getEvents());
      schedulerData.config.nonAgendaDayCellHeaderFormat = 'ha';
      if (view.viewType === 5) {
        schedulerData.config.nonAgendaDayCellHeaderFormat = 'D, ddd |ha';
      }
      this.setState({
        viewModel: schedulerData,
      });
    }
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    this.setState(
      {
        viewModel: schedulerData,
      },
      () => this.setCalenderData(this.state.viewModel)
    );
  };

  eventClicked = (schedulerData, event) => {
    this.props.getJobDetailsAction(event.id);
    this.props.setCurrentEvent(event);
    this.props.toggleEditJobModal(true);
  };

  newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
    this.captureScrollLeft();
    saveEvent(EVENTS.JOB_LINK_DAY_DRAG_AND_DROP_A_JOB, {});
    if (!item) return false;
    const newEvent = {
      id: item.id,
      title: item.name,
      start,
      end,
      resourceId: slotId,
      startResizable: true,
      endResizable: true,
      isNew: true,
      save: true,
    };
    this.props.setCurrentEvent(newEvent);
    this.props.getJobDetailsAction(item.id);
    this.props.toggleEditJobModal(true);
  };

  moveEvent = (schedulerData, event, slotId, slotName, start, end, type, item) => {
    this.captureScrollLeft();
    this.props.getJobDetailsAction(event.id);
    this.props.setCurrentEvent({ ...event, start, save: true, isNew: false, resourceId: slotId });
    this.props.toggleEditJobModal(true);
  };

  onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData.ViewTypes === ViewTypes.Day) {
      schedulerData.next();
      schedulerData.setEvents(this.getEvents());
      this.setState({
        viewModel: schedulerData,
      });

      schedulerContent.scrollLeft = maxScrollLeft - 10;
    }
  };

  onScrollLeft = (schedulerData, schedulerContent) => {
    if (schedulerData.ViewTypes === ViewTypes.Day) {
      schedulerData.prev();
      schedulerData.setEvents(this.getEvents());
      this.setState({
        viewModel: schedulerData,
      });

      schedulerContent.scrollLeft = 10;
    }
  };
}

Basic.propTypes = {
  setSchedulerData: PropTypes.func,
  setNewEvent: PropTypes.func,
  setTaskDndSource: PropTypes.func,
  toggleEditJobModal: PropTypes.func,
  getJobDetailsAction: PropTypes.func,
  getTeamListWithFiltersAction: PropTypes.func,
  teamListDetails: PropTypes.object,
  setCurrentEvent: PropTypes.func,
  viewType: PropTypes.number,
  onRef: PropTypes.func,
  setCalenderViewData: PropTypes.func,
  calenderViewData: PropTypes.object,
  jobList: PropTypes.object,
  assignedJob: PropTypes.object,
  getJobListAction: PropTypes.func,
  resourceReportCategory: PropTypes.array,
  updateStatusAction: PropTypes.func,
  isStatusUpdated: PropTypes.bool,
  statusUpdateError: PropTypes.string,
  reportCategories: PropTypes.array,
  setResourceReportCategory: PropTypes.func,
  isStatusUpdateFetching: PropTypes.bool,
  search: PropTypes.string,
  isSearch: PropTypes.bool,
  handleOnSearch: PropTypes.func,
};

const mapStateToProps = (store) => ({
  teamListDetails: checkPermission(
    subPermissions.scheduleOthersJobs,
    permissions.jobLink
  )
    ? store.jobListDetails.teamListWithFilters
    : checkPermission(subPermissions.scheduleMyJobs, permissions.jobLink)
    ? {
        ...store.jobListDetails.teamListWithFilters,
        pages: 1,
        totalListCount: 1,
        teamList: store.jobListDetails.teamListWithFilters.teamList.filter(
          (item) => item._id === store.auth.login.user.customerId
        ),
      }
    : store.jobListDetails.teamListWithFilters,
  calenderViewData: store.jobListDetails.calenderViewData,
  jobList: store.jobListDetails.jobList,
  assignedJob: store.jobListDetails.assignedJob,
  isStatusUpdated: store.updateStatus.isSuccess,
  statusUpdateError: store.updateStatus.error,
  isStatusUpdateFetching: store.updateStatus.isfetching,
  reportCategories: Object.keys(store.reportCategory.reportData),
  auth: store.auth,
});

export default connect(mapStateToProps, {
  getJobDetailsAction,
  getTeamListWithFiltersAction,
  setCalenderViewData,
  getJobListAction,
  updateStatusAction,
})(Basic);
